import { titleString } from '@cp/src/constants/Global';
import { Typography } from '@navi/web-ui/lib/primitives';
import cx from 'classnames';
import styles from './index.module.scss';
import { CountTagProps } from './interface';

const CountTag = (props: CountTagProps) => {
  const { unreadNotificationCount, notificationCountClass } = props;

  if (!unreadNotificationCount || unreadNotificationCount < 1) {
    document.title = titleString(0);
    return null;
  }

  const displayCount = unreadNotificationCount > 99 ? '99+' : unreadNotificationCount;

  document.title = titleString(displayCount);

  return (
    <Typography variant="h6" className={cx(styles.notificationCount, notificationCountClass)}>
      {displayCount}
    </Typography>
  );
};

export default CountTag;
